import { Injectable } from '@angular/core';
import {
  Actions,
  createEffect,
  EffectNotification,
  ofType,
  OnRunEffects,
} from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
  catchError,
  exhaustMap,
  mergeMap,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { UsersStorageService } from 'src/app/core/storage/users-storage.service';
import * as StoreActions from '../actions/store.actions';
import * as AuthActions from '../actions/auth.actions';
import { arrayToObject } from 'src/app/core/base/utils/helper.function';
import { ErrorService } from 'src/app/services/error.service';

@Injectable()
export class StoreEffects implements OnRunEffects {
  constructor(
    private actions$: Actions,
    private errorService: ErrorService,
    private usersStorageService: UsersStorageService
  ) {}

  loadAuthState$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StoreActions.loadAuthState),
      switchMap(async () => {
        return await this.usersStorageService.getAuthState();
      }),
      mergeMap((result) => {
        const users = arrayToObject(
          result.users,
          (x) => x.id,
          (x) => x
        );
        // 1st do updateAuthState and then authStateLoaded
        return of(
          AuthActions.updateAuthState({
            payload: { users, activeUser: result.activeUser },
          }),
          StoreActions.authStateLoaded()
        );
      }),
      catchError((error) => {
        return of(
          StoreActions.loadAuthStateFail({
            payload: { error: this.errorService.mapError(error) },
          })
        );
      })
    );
  });
  // *Run until the store has finished App initialization
  ngrxOnRunEffects(
    resolvedEffects$: Observable<EffectNotification>
  ): Observable<EffectNotification> {
    return this.actions$.pipe(
      ofType(StoreActions.startAppInit),
      exhaustMap(() => {
        //ignore other values until that observable completes
        return resolvedEffects$.pipe(
          takeUntil(this.actions$.pipe(ofType(StoreActions.finishAppInit))) //Emit values until provided observable emits
        );
      })
    );
  }
}
